/* Mur d'avis : onglets, ajout au clic, agrandissement.

   Regle qui commande tout le fichier (owner, 16/09) : une photo ou une video que
   personne n'a demandee ne doit RIEN peser. Le serveur rend 12 cartes ; le reste
   du fonds arrive au premier clic, et les <img>/<video> ne sont crees qu'au
   moment ou une carte devient visible. `loading="lazy"` n'aurait pas suffi : une
   image cachee peut quand meme partir en telechargement. */
(function () {
  var mur = document.getElementById('avis-mur');
  if (!mur) return;
  var grille = document.getElementById('avis-grid');
  var plus = mur.querySelector('[data-avis-plus]');
  var lb = document.getElementById('avis-lb');
  var scene = lb && lb.querySelector('.avis-mur__lb-scene');
  var PAS = 12;
  var fonds = null, onglet = 'tous', charge = null, occupe = false;
  var photos = [], iPhoto = 0;      // etat de l'agrandissement photo en cours
  // Index des avis du fonds deja poses dans la grille. Les 12 premiers sont
  // rendus par le serveur, donc deja pris.
  var rendus = {};
  for (var d0 = 0; d0 < 12; d0++) rendus[d0] = 1;

  /* Le cadre a ratio est pose DES LA CREATION de la carte, comme le fait le
     rendu serveur. Sans lui, une carte creee par le JS reste de hauteur nulle
     jusqu'a l'arrivee de son image, et la pastille de lecture d'une video
     deborde par-dessus la carte du dessus. Vu a l'ecran le 17/09. */
  function cadreVide(ra) {
    var r = parseFloat(ra || '1.33');
    return '<div class="image-aspect-ratio-wrapper">' +
           '<div class="image-aspect-ratio" style="padding-bottom:' + (r * 100).toFixed(0) + '%"></div>' +
           '</div>';
  }

  /* ===== Les colonnes =====
     `column-count` redistribue tout son contenu a chaque ajout : les cartes
     deja lues changeaient de place au clic sur « Voir plus ». On passe donc a
     de vraies colonnes, remplies a la main : une carte posee ne bouge plus
     jamais, et une nouvelle va dans la colonne la plus courte. */
  var colonnes = [];
  // Toutes les cartes creees, dans l'ordre du fonds. C'est la reference : les
  // colonnes ne sont qu'un affichage, on les vide et on les remplit a partir
  // de ce tableau quand l'onglet change ou quand la largeur change de palier.
  var toutes = [];

  function nbColonnes() {
    var v = parseInt(getComputedStyle(grille).getPropertyValue('--avis-colonnes'), 10);
    return (v > 0 && v < 9) ? v : 2;
  }

  function construireColonnes() {
    var n = nbColonnes();
    if (!toutes.length) {
      toutes = Array.prototype.slice.call(grille.querySelectorAll('.grid-item-wrap'));
    }
    colonnes = [];
    grille.textContent = '';
    for (var i = 0; i < n; i++) {
      var c = document.createElement('div');
      c.className = 'avis-mur__col';
      grille.appendChild(c);
      colonnes.push(c);
    }
    grille.classList.add('is-colonnes');
    posees = 0;
    toutes.forEach(function (c) {
      if (onglet === 'tous' || c.dataset.genre === onglet) poser(c);
    });
  }

  function plusCourte() {
    var min = colonnes[0];
    for (var i = 1; i < colonnes.length; i++) {
      if (colonnes[i].offsetHeight < min.offsetHeight) min = colonnes[i];
    }
    return min;
  }

  /* Au premier remplissage les colonnes sont vides et toutes de hauteur 0 :
     `plusCourte` renverrait toujours la premiere. On repartit donc en tourniquet
     tant qu'aucune colonne n'a recu sa premiere carte. */
  var posees = 0;
  function poser(carte) {
    carte.hidden = false;
    var col = (posees < colonnes.length) ? colonnes[posees] : plusCourte();
    col.appendChild(carte);
    posees++;
  }

  function recomposer(force) {
    if (!colonnes.length) return;
    if (!force && colonnes.length === nbColonnes()) return;   // meme palier
    construireColonnes();
  }

  var paliers;
  function surveillerLargeur() {
    if (!window.matchMedia) return;
    paliers = [480, 920, 1150].map(function (px) { return window.matchMedia('(min-width:' + px + 'px)'); });
    paliers.forEach(function (m) {
      var h = function () { recomposer(); };
      if (m.addEventListener) m.addEventListener('change', h);
      else if (m.addListener) m.addListener(h);
    });
  }

  function genreDe(a) {
    return a.vi && a.vi.length ? 'video' : (a.p && a.p.length ? 'photo' : 'texte');
  }
  var MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet',
              'août', 'septembre', 'octobre', 'novembre', 'décembre'];

  function ech(t) {
    var d = document.createElement('div'); d.textContent = t == null ? '' : t;
    return d.innerHTML;
  }

  function etoiles(n) {
    var s = '';
    for (var i = 1; i <= 5; i++) {
      s += '<svg viewBox="0 0 24 24" class="avis-icon star" data-lx-fill="' +
           (i <= n ? 'full' : 'empty') + '" aria-hidden="true">' +
           '<use href="#avis-star-line" class="lx-icon-line"></use>' +
           '<use href="#avis-star-fill" class="lx-icon-fill"></use></svg>';
    }
    return '<span class="stars-row" role="img" aria-label="' + n + ' étoiles sur 5">' + s + '</span>';
  }

  /* La carte sort SANS media charge : l'URL attend dans data-src, et
     `afficher()` ne cree la balise qu'au moment ou la carte entre dans le mur. */
  function carte(a) {
    var genre = genreDe(a);
    var med = '';
    if (genre === 'video') {
      var v = a.vi[0];
      med = '<div class="item-img box" data-avis-video="' + ech(v.u) + '" data-poster="' + ech(v.p) + '"' +
            ' data-ratio="' + v.ra + '" role="button" tabindex="0" aria-label="Lire la vidéo">' +
            cadreVide(v.ra) +
            '<span class="avis-play" aria-hidden="true"></span></div>';
    } else if (genre === 'photo') {
      var p = a.p[0];
      med = '<div class="item-img box" data-avis-photos=\'' + JSON.stringify(a.p.map(function (x) { return x.u; })) + '\'' +
            ' data-src="' + ech(p.u) + '" data-ratio="' + p.ra + '"' +
            ' data-w="' + p.w + '" data-h="' + p.h + '" role="button" tabindex="0"' +
            ' aria-label="Agrandir la photo">' +
            cadreVide(p.ra) +
            (a.p.length > 1 ? '<span class="multi-photo-badge"><svg viewBox="0 0 20 20" aria-hidden="true">' +
              '<use href="#avis-multi"></use></svg>+' + (a.p.length - 1) + '</span>' : '') +
            '</div>';
    }
    var d = (a.d || '').split('-');
    var date = d.length === 3 ? (+d[2]) + ' ' + MOIS[+d[1] - 1] + ' ' + d[0] : '';
    // 25/09 (owner) : avis reçus en direct, jour exact inconnu : on affiche le mois seul (champ dm), jamais une date inventée.
    if (a.dm) date = a.dm;
    var verif = a.v ? '<span class="verified-badge-and-text"><svg viewBox="0 0 24 24"' +
      ' class="avis-icon avis-badge-verifie" role="img" aria-label="Achat vérifié">' +
      '<use href="#avis-verifie"></use></svg><span>Vérifié</span></span>' : '';
    var el = document.createElement('div');
    el.className = 'grid-item-wrap' + (med ? ' has-img' : '');
    el.dataset.genre = genre;
    el.innerHTML = '<div class="grid-item clearfix">' + med + '<div class="main"><div class="box">' +
      '<div class="block title">' + ech(a.a) + verif + '</div>' +
      '<div class="block time">' + date + '</div>' +
      '<div class="block stars">' + etoiles(a.no) + '</div>' +
      '<div class="block"><div class="pre-wrap main-text">' + ech(a.t) + '</div></div>' +
      '</div></div></div>';
    return el;
  }

  /* C'est ici, et seulement ici, qu'un media commence a se telecharger.
     Appele par l'observateur ci-dessous quand la carte approche de l'ecran, ou
     tout de suite pour une carte que le visiteur vient de demander. */
  function afficher(box) {
    if (!box || box.dataset.pret) return;
    box.dataset.pret = '1';
    var src = box.dataset.src || box.dataset.poster;
    if (!src) return;
    var cadre = box.querySelector('.image-aspect-ratio-wrapper');
    if (!cadre) {
      // Carte creee par le JS : le cadre n'existe pas encore.
      var r = parseFloat(box.dataset.ratio || '1.33');
      cadre = document.createElement('div');
      cadre.className = 'image-aspect-ratio-wrapper';
      cadre.innerHTML = '<div class="image-aspect-ratio" style="padding-bottom:' +
                        (r * 100).toFixed(0) + '%"></div>';
      box.insertBefore(cadre, box.firstChild);
    }
    if (cadre.querySelector('img')) return;
    var img = document.createElement('img');
    img.src = src + '&width=400';
    img.srcset = src + '&width=300 300w, ' + src + '&width=450 450w, ' + src + '&width=600 600w';
    img.sizes = '(min-width:1150px) 250px, (min-width:920px) 310px, (min-width:480px) 33vw, 50vw';
    img.alt = box.dataset.avisVideo ? "Avis vidéo d'un client" : "Photo d'un client";
    img.decoding = 'async';
    if (box.dataset.w) { img.width = box.dataset.w; img.height = box.dataset.h; }
    cadre.appendChild(img);
  }

  /* Rien ne se telecharge avant que la carte approche. Marge de 300 px pour que
     l'image soit la quand elle arrive a l'ecran, sans la demander pour rien. */
  var guetteur = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entrees) {
    entrees.forEach(function (e) {
      if (!e.isIntersecting) return;
      afficher(e.target);
      guetteur.unobserve(e.target);
    });
  }, { rootMargin: '300px 0px' }) : null;

  function guetter(box) {
    if (!box) return;
    if (guetteur) guetteur.observe(box);
    else afficher(box);          // vieux navigateur : on charge tout de suite
  }

  function guetterTout() {
    grille.querySelectorAll('.item-img:not([data-pret])').forEach(guetter);
  }



  function visibles() {
    return grille.querySelectorAll('.grid-item-wrap').length;
  }

  function filtre() {
    recomposer(true);          // vide les colonnes et repose le genre courant
    guetterTout();
  }

  /* Un SEUL curseur pour trois onglets, c'etait un piege : en passant sur
     « Videos », la boucle consommait le curseur sur tous les avis photo et texte
     qu'elle sautait. De retour sur « Tout », ces avis-la etaient perdus pour de
     bon, et le bouton « Voir plus » disparaissait alors qu'il restait des
     centaines d'avis a montrer. On retient donc les index DEJA rendus et on
     reparcourt le fonds depuis le debut : l'ordre est conserve, rien ne se perd. */
  function ajouter(n) {
    if (!fonds) return 0;
    var mis = 0;
    for (var k = 0; k < fonds.liste.length && mis < n; k++) {
      if (rendus[k]) continue;
      var a = fonds.liste[k];
      if (onglet !== 'tous' && genreDe(a) !== onglet) continue;
      rendus[k] = 1;
      var el = carte(a);
      toutes.push(el);
      poser(el);
      guetter(el.querySelector('.item-img'));
      mis++;
    }
    majBouton();
    return mis;
  }

  function reste() {
    if (!fonds) return 1;   // pas encore charge : on ne sait pas, on garde le bouton
    for (var k = 0; k < fonds.liste.length; k++) {
      if (!rendus[k] && (onglet === 'tous' || genreDe(fonds.liste[k]) === onglet)) return 1;
    }
    return 0;
  }

  function majBouton() {
    if (!plus) return;
    if (reste()) {
      if (!plus.parentNode) mur.insertBefore(plus, lb);
    } else if (plus.parentNode) {
      plus.parentNode.removeChild(plus);
    }
  }

  function charger() {
    if (charge) return charge;
    charge = fetch(mur.dataset.fonds).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    }).then(function (j) {
      fonds = j;
      return j;
    }).catch(function () {
      // Le fonds n'a pas repondu : on laisse le bouton, un nouveau clic reessaie.
      charge = null;
      return null;
    });
    return charge;
  }

  construireColonnes();
  surveillerLargeur();
  guetterTout();

  if (plus) {
    plus.addEventListener('click', function () {
      if (occupe) return;          // un double clic ne doit pas ajouter deux fois
      occupe = true;
      plus.disabled = true;
      charger().then(function () {
        ajouter(PAS);
        occupe = false;
        plus.disabled = false;
      });
    });
  }

  mur.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-onglet]');
    if (tab) {
      onglet = tab.dataset.onglet;
      mur.querySelectorAll('[data-onglet]').forEach(function (b) {
        b.setAttribute('aria-selected', String(b === tab));
      });
      filtre();
      majBouton();
      // L'onglet Videos n'a presque rien dans le premier ecran : on complete.
      if (visibles() < PAS) {
        charger().then(function () { ajouter(PAS - visibles()); });
      }
      return;
    }
    var box = e.target.closest('[data-avis-photos],[data-avis-video]');
    if (!box || !lb || !lb.showModal) return;
    if (box.dataset.avisVideo) {
      photos = [];              // sinon les fleches d'une photo ouverte avant restent actives
      scene.innerHTML = '<video src="' + box.dataset.avisVideo + '" poster="' + (box.dataset.poster || '') +
        '" controls autoplay playsinline preload="none"></video>';
      lb.querySelectorAll('.avis-mur__lb-nav').forEach(function (b) { b.hidden = true; });
      lb.showModal();
      return;
    }
    var liste;
    try { liste = JSON.parse(box.dataset.avisPhotos); } catch (err) { return; }
    if (!liste.length) return;
    photos = liste; iPhoto = 0; voirPhoto(); lb.showModal();
  });

  function voirPhoto() {
    scene.innerHTML = '<img src="' + photos[iPhoto] + '&width=1400" alt="Photo d\'un client">';
    lb.querySelectorAll('.avis-mur__lb-nav').forEach(function (b) { b.hidden = photos.length < 2; });
  }

  // Ouvrir au clavier : la carte porte role="button" et tabindex="0", il faut
  // donc que Entree et Espace fassent ce que fait le clic.
  mur.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var box = e.target.closest('[data-avis-photos],[data-avis-video]');
    if (!box) return;
    e.preventDefault();
    box.click();
  });

  function fermer() {
    if (!lb) return;
    lb.close();
    scene.innerHTML = '';   // coupe le son et la lecture d'une video ouverte
    photos = [];
  }
  if (lb) {
    lb.addEventListener('click', function (e) {
      var nav = e.target.closest('[data-sens]');
      if (nav && photos.length > 1) {
        iPhoto = (iPhoto + Number(nav.dataset.sens) + photos.length) % photos.length;
        voirPhoto();
        return;
      }
      if (e.target === lb || e.target.closest('.avis-mur__lb-x')) fermer();
    });
    // La touche Echap ferme le dialogue toute seule : on vide la scene pour
    // couper le son d'une video restee en lecture.
    lb.addEventListener('close', function () { scene.innerHTML = ''; photos = []; });
  }
})();
